import { t } from 'i18next'
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const FinancialExposurePage = lazy(() => import('../containers/FinancialExposure/FinancialExposureContainer'))
// const UserProfilePage = lazy(() => import('../containers/UserManagement/UserProfile/UserProfileContainer'))
// const AuthorizationsGroupsPage = lazy(() => import('../containers/UserManagement/AuthorizationsGroups/AuthorizationsGroupsContainer'))

export const FINANCIAL_EXPOSURE_PATHS = {
  HOME: '/financial-exposure',
} as const

export const financialExposureRoutes: RouteObject[] = [
  {
    path: FINANCIAL_EXPOSURE_PATHS.HOME,
    children: [
      {
        index: true,
        element: <FinancialExposurePage/>,
        handle: {
          crumb: (): MenuItem[] => [
            { label: t('general:menu.financial_exposure') || '', url: FINANCIAL_EXPOSURE_PATHS.HOME },
          ],
        },
      },
    ],
  },
]
